import { ContentUndo } from '@fs/zion-icon'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useOverlay, IconButton } from '@fs/zion-ui'
import RestoreSelectedArtifactsOverlay from '../overlay/RestoreSelectedArtifactsOverlay'

export default function RestoreSelectedActionButton({ checkedArtifacts, setCheckedArtifacts, refetch, patron }) {
  const { t } = useTranslation()
  const restoreSelectedArtifactsOverlay = useOverlay()

  return (
    <>
      <IconButton
        title={t('action.restoreSelected', 'Restore Selected')}
        onClick={restoreSelectedArtifactsOverlay.handleClick}
        Icon={ContentUndo}
        color="green"
        emphasis="high"
      />
      <RestoreSelectedArtifactsOverlay
        checkedArtifacts={checkedArtifacts}
        setCheckedArtifacts={setCheckedArtifacts}
        onSuccess={() => refetch()}
        patronId={patron?.id}
        {...restoreSelectedArtifactsOverlay}
      />
    </>
  )
}
